import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_5 = { class: "text-xs text-gray-500 dark:text-gray-400 text-center pt-2" }

import * as z from "zod";
import type { FormError, FormSubmitEvent } from "#ui/types";
import { contactSaleSchema, type ContactSaleSchema } from "~/schemas/contact-sale";
import { useAuthStore } from "~/stores/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactSaleForm',
  emits: ["success", "error"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const auth = useAuthStore();
const isSubmitting = ref(false);
const submitError = ref<string>();

const schema = contactSaleSchema;

const state = reactive<ContactSaleSchema>({
  firstName: "",
  lastName: "",
  email: "",
  jobTitle: "",
  companyName: "",
  companySize: "",
  country: "",
  phoneNumber: "",
  reasonForContact: "",
  additionalDetails: null,
  marketingOptIn: false,
});

const companySizeOptions = [
  { label: "1-10 employees", value: "1-10" },
  { label: "11-50 employees", value: "11-50" },
  { label: "51-200 employees", value: "51-200" },
  { label: "201-500 employees", value: "201-500" },
  { label: "501-1000 employees", value: "501-1000" },
  { label: "1000+ employees", value: "1000+" },
];

const reasonOptions = [
  { label: "Book introduction", value: "book-introduction" },
  { label: "Schedule a demo", value: "schedule-demo" },
  { label: "Request pricing information", value: "pricing" },
  { label: "Discuss a custom solution", value: "custom-solution" },
  { label: "Ask a support question", value: "support" },
  { label: "Something else", value: "other" },
];

// Watch for changes on submitError
watch(submitError, (newValue) => {
  if (newValue) {
    setTimeout(() => {
      submitError.value = undefined;
    }, 5000);
  }
});

async function onSubmit(payload: FormSubmitEvent<ContactSaleSchema>) {
  isSubmitting.value = true;
  submitError.value = undefined;

  try {
    await auth.api("POST", "/contact/sale", payload.data);
    emit("success");
  } catch (error: any) {
    const errorMessage =
      error?.data?.message ||
      error?.message ||
      "An error occurred while submitting the form. Please try again.";
    submitError.value = errorMessage;
    emit("error", errorMessage);
    console.error("Contact sale form submission error:", error);
  } finally {
    isSubmitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_UInput = _resolveComponent("UInput")!
  const _component_UFormField = _resolveComponent("UFormField")!
  const _component_USelect = _resolveComponent("USelect")!
  const _component_UTextarea = _resolveComponent("UTextarea")!
  const _component_UCheckbox = _resolveComponent("UCheckbox")!
  const _component_UAlert = _resolveComponent("UAlert")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_UForm = _resolveComponent("UForm")!

  return (_openBlock(), _createBlock(_component_UForm, {
    schema: _unref(schema),
    state: _unref(state),
    class: "space-y-6",
    onSubmit: onSubmit
  }, {
    default: _withCtx(() => [
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mb-6" }, [
        _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900 dark:text-white mb-2" }, "Contact us"),
        _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Share a few details below and a member of our team will get back to you soon. ")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_UFormField, {
          label: "First name",
          name: "firstName",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UInput, {
              modelValue: _unref(state).firstName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).firstName) = $event)),
              placeholder: "Enter your first name",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_UFormField, {
          label: "Last name",
          name: "lastName",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UInput, {
              modelValue: _unref(state).lastName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).lastName) = $event)),
              placeholder: "Enter your last name",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UFormField, {
          label: "Work email",
          name: "email",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UInput, {
              modelValue: _unref(state).email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).email) = $event)),
              type: "email",
              placeholder: "you@company.com",
              icon: "i-heroicons-envelope",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_UFormField, {
          label: "Job title",
          name: "jobTitle",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UInput, {
              modelValue: _unref(state).jobTitle,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).jobTitle) = $event)),
              placeholder: "e.g., Director, Manager, Operations Lead",
              icon: "i-heroicons-briefcase",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_UFormField, {
          label: "Company name",
          name: "companyName",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UInput, {
              modelValue: _unref(state).companyName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).companyName) = $event)),
              placeholder: "Enter your company name",
              icon: "i-heroicons-building-office",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_UFormField, {
          label: "Company size",
          name: "companySize",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_USelect, {
              modelValue: _unref(state).companySize,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).companySize) = $event)),
              items: companySizeOptions,
              placeholder: "Select company size",
              "option-attribute": "label",
              "value-attribute": "value",
              icon: "i-heroicons-user-group",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_UFormField, {
          label: "Country or region",
          name: "country",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UInput, {
              modelValue: _unref(state).country,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).country) = $event)),
              placeholder: "Enter your country or region",
              icon: "i-heroicons-map-pin",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_UFormField, {
          label: "Phone number",
          name: "phoneNumber",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UInput, {
              modelValue: _unref(state).phoneNumber,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).phoneNumber) = $event)),
              type: "tel",
              placeholder: "+44 20 1234 5678",
              icon: "i-heroicons-phone",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-3" }, "Reason for contact:", -1)),
        _createVNode(_component_UFormField, {
          name: "reasonForContact",
          required: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_USelect, {
              modelValue: _unref(state).reasonForContact,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).reasonForContact) = $event)),
              items: reasonOptions,
              placeholder: "Select a reason",
              "option-attribute": "label",
              "value-attribute": "value",
              icon: "i-heroicons-chat-bubble-left-right",
              class: "w-full"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_UFormField, {
        label: "Additional details",
        name: "additionalDetails",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UTextarea, {
            modelValue: _unref(state).additionalDetails,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).additionalDetails) = $event)),
            placeholder: "Tell us more about your needs...",
            rows: 4,
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_UFormField, {
        name: "marketingOptIn",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UCheckbox, {
            modelValue: _unref(state).marketingOptIn,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).marketingOptIn) = $event)),
            label: "Yes, I'd like to hear about updates and news from FamilyAxis."
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      (_unref(submitError))
        ? (_openBlock(), _createBlock(_component_UAlert, {
            key: 0,
            color: "red",
            variant: "soft",
            icon: "i-heroicons-exclamation-triangle-20-solid",
            title: "Submission Error",
            description: _unref(submitError),
            class: "mb-4"
          }, null, 8, ["description"]))
        : _createCommentVNode("", true),
      _createVNode(_component_UButton, {
        type: "submit",
        loading: _unref(isSubmitting),
        size: "lg",
        block: "",
        class: "mt-2"
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
          _createTextVNode(" Submit your details ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"]),
      _createElementVNode("p", _hoisted_5, [
        _cache[15] || (_cache[15] = _createTextVNode(" By submitting this form, you agree to our ", -1)),
        _createVNode(_component_NuxtLink, {
          to: "/privacy-policy",
          class: "underline hover:text-gray-700 dark:hover:text-gray-300"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("Privacy Policy", -1)
          ]))]),
          _: 1
        }),
        _cache[16] || (_cache[16] = _createTextVNode(" and ", -1)),
        _createVNode(_component_NuxtLink, {
          to: "/terms",
          class: "underline hover:text-gray-700 dark:hover:text-gray-300"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode("Terms of Service", -1)
          ]))]),
          _: 1
        }),
        _cache[17] || (_cache[17] = _createTextVNode(". ", -1))
      ])
    ]),
    _: 1
  }, 8, ["schema", "state"]))
}
}

})